import { Component, OnInit, Output, EventEmitter, Input, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { NzCascaderOption } from 'ng-zorro-antd/cascader';
import { _HttpClient } from 'src/app/core/net/http.client';
import { ApiService } from '../../net/apiRoute';
 

@Component({
  selector: 'app-select-areas',
  templateUrl: './app-select-areas.component.html',
  styleUrls: ['./app-select-areas.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AppSelectAreasComponent),
      multi: true,
    }
  ]
  
})

export class AppSelectAreasComponent implements OnInit {
  @Input() maxLayer:number=3;
  @Input() values:[] | null = null;                         // 指定选中项 默认值
  @Output() selectLabelEvent:EventEmitter<string> = new EventEmitter(); // 输出键集合
  @Output() selectValueEvent :EventEmitter<string> = new EventEmitter(); // 输出值集合
  constructor(private http:_HttpClient) {
  
  }


  ngOnInit(): void {

  }
  propagateChange = (_: any) => { };
  writeValue(value: any): void {
    this.values = value;
  }
  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any): void {

  }
  setDisabledState?(isDisabled: boolean): void {

  }
  /**
   *
   * @param values 下拉框改变事件
   */
  onChanges(e): void {
    this.propagateChange(e);
    this.selectValueEvent.emit(e);
  }

  /**
   * 值发生变化时触发
   * @param e
   */
  onSelectionChange(e){
    this.selectLabelEvent.emit(e.map(x=>x.label));
  }

  /**
   * 加载数据源
   */
  loadData = (node: NzCascaderOption, index: number): PromiseLike<void>=> {
    let parentId = '0';
    if (index != -1) {
      parentId = node?.value;
    }
    return  this.http
    .get(ApiService.GetCascaderSource,{'parentId':parentId,'layer':index,'maxLayer':this.maxLayer},false)
    .toPromise()
    .then( x=>node.children = x.Result);
  }
}
